<template>
  <div class="admin">
    <div class="section create">
      <button class="button">
        <router-link :to="{ path: '/edit-event/' }">Create Event</router-link>
      </button>
      
      <button class="button">
        <router-link :to="{ path: '/edit-update/' }">Create Update</router-link>
      </button>
    </div>
    <div class="columns">
      <div class="column is-one-third list-events has-background-grey-lighter">
        <h1 class="h1">Events</h1>
        <div class="event" v-for="(event, eventIndex) in events" :key="event.id">
          <div>
            <span class="preview-link" @click="previewEvent(eventIndex)">{{event.title}}</span>
            <router-link class="is-pulled-right" :to="{ path: '/edit-event/' + event.id}">Edit</router-link>
          </div>
        </div>
      </div>
      <div class="column is-one-third list-updates has-background-warning">
        <h1 class="h1">Updates</h1>
        <div class="update" v-for="(update, updateIndex) in updates" :key="update.id">
          <div>
            <span
              class="preview-link"
              @click="previewUpdate(updateIndex)"
            >{{update.message.substring(0, 30)}} ...</span>
            <router-link class="is-pulled-right" :to="{ path: '/edit-update/' + update.id}">Edit</router-link>
          </div>
        </div>
      </div>
      <div class="column view">
        <div v-if="updateToView">
          <button class="button">Start : {{ new Date(updateToView.dateCreated.seconds * 1000) }}</button>
          <p class="content" v-html="markdownUpdateContent"></p>
        </div>

        <div class="has-background-danger divider"></div>

        <div v-if="eventToView">
          <img width="500px" :src="eventToView.posterUri" />
          <p class="is-size-4">{{eventToView.title}}</p>
          <p class="content" v-html="markdownEventContent"></p>
          <div class="dates">
            <button class="button">Start : {{ new Date(eventToView.startDate.seconds * 1000) }}</button>
            <button class="button">End : {{ new Date(eventToView.endDate.seconds * 1000) }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { firestore } from "@/firebase";
import marked from "marked";

export default {
  data() {
    return {
      eventToView: null,
      updateToView: null,
      events: null,
      updates: null
    };
  },
  mounted() {
    firestore.collection("Events").onSnapshot(snapshot => {
      let events = snapshot.docs.map(d => {
        var data = d.data();
        data.id = d.id;
        return data;
      });
      this.events = events.sort((a, b) =>
        a.startDate.seconds > b.startDate.seconds ? -1 : 1
      );
    });

    firestore.collection("Updates").onSnapshot(snapshot => {
      let updates = snapshot.docs.map(d => {
        var data = d.data();
        data.id = d.id;
        return data;
      });
      console.log(updates);
      this.updates = updates.sort((a, b) =>
        a.dateCreated.seconds > b.dateCreated.seconds ? -1 : 1
      );
    });
  },
  methods: {
    previewEvent: function(index) {
      this.eventToView = this.events[index];
    },
    previewUpdate: function(index) {
      this.updateToView = this.updates[index];
    }
  },
  computed: {
    markdownEventContent: function() {
      if (this.eventToView) {
        return marked(this.eventToView.description);
      } else {
        return null;
      }
    },
    markdownUpdateContent: function() {
      if (this.updateToView) {
        return marked(this.updateToView.message);
      } else {
        return null;
      }
    }
  }
};
</script>

<style scoped>
.event {
  padding: 3px;
}
.event:not(last-child) {
  border-bottom: solid 1px gray;
}

.update {
  padding: 3px;
}
.update:not(last-child) {
  border-bottom: solid 1px gray;
}

p button {
  margin-left: 5px;
}
.dates button {
  display: block;
  margin-bottom: 3px;
  margin-top: 3px;
}
.preview-link {
  cursor: pointer;
}

.divider {
  height: 10px;
  margin: 10px 0px ;
}

.create .button {
  margin-right: 10px;
}
</style>
